import * as navigate from 'app/area/shared/navigation';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { api } from './api';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { isCaseViewModalOpen } from 'app/components/helpers';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';

export const actionCreators = {

  duplicateCase: (caseId: number): ActionDispatching<any, ApplicationState> => 
    async (dispatch: any, getState: ()=> ApplicationState) => {
      try{
        const { utcOffset } = getState().app.settings;
        const { draftId, messages } = await api.duplicateCase(caseId, {utcOffset});
        messages?.userMessages?.forEach((userMessage: { message: string }) => {
          if (userMessage?.message) {
            const toasts = toastFactory();
            toasts.dispatchWarning(userMessage.message);
          }
        });
        isCaseViewModalOpen() ? navigate.toDraftCaseViewModal(draftId) : navigate.toDraft(draftId);
      }catch (err) {
        dispatch(new ErrorNotification(err.userMessages || err.message));
        navigate.toCaseView(caseId);
      }
    }
};
